import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'
import { EMAIL_REGEX, PHONE_REGEX, MIN_PASSWORD_LENGTH } from "../utils/constants"
import { requiredPostalCode } from "./postalCodeSchema"

export const MYPROFILE_SCHEMA = Yup.object().shape({
    washname: Yup.string().required(CommonMessages.washname_required),
    address1: Yup.string().required(CommonMessages.address_required),
    city: Yup.string().required(CommonMessages.city_required),
    country: Yup.string().required(CommonMessages.country_required),
    state: Yup.string().required(CommonMessages.state_required),
    zipcode: requiredPostalCode(),
    name: Yup.string().required(CommonMessages.name_required),
    // email: Yup.string()
    //     .matches(EMAIL_REGEX, CommonMessages.email_invalid)
    //     .required(CommonMessages.email_required),
    phonenumber: Yup.string()
        .matches(PHONE_REGEX, 'Phone number is not valid')
        .required(CommonMessages.phone_required),
});

export const CHANGE_PASSWORD_SCHEMA = Yup.object({
    oldpassword: Yup.string().trim().min(MIN_PASSWORD_LENGTH, CommonMessages.password_minimum).required(CommonMessages.oldpassword_required),
    newpassword: Yup.string().trim().min(MIN_PASSWORD_LENGTH, CommonMessages.password_minimum).required(CommonMessages.password_required),
    retypepassword: Yup.string().trim().oneOf([Yup.ref('newpassword')], CommonMessages.password_match).required(CommonMessages.password_required),
});

export const PAYMENT_INFO_SCHEMA = Yup.object({

    accountnumber: Yup.string()
        .required(CommonMessages.accountnumber_required)
        .matches(/^\d{6,17}$/, CommonMessages.accountnumber_mismatch)
        .test('no-x-characters', CommonMessages.accountnumber_fullrequired, (value) => {
            // Check if the value contains "XXXX"
            return !value || !value.includes('XXXX');
        }),

    routingnumber: Yup.string()
        .required(CommonMessages.routingnumber_required)
        .matches(/^\d{9}$/, CommonMessages.routingnumber_mismatch),

    retypeaccountnumber: Yup.string()
        .required(CommonMessages.accountnumber_required)
        .matches(/^\d{6,17}$/, CommonMessages.accountnumber_mismatch)
        .trim()
        .oneOf([Yup.ref('accountnumber')], CommonMessages.accountnumber_match)
        .test('no-x-characters', CommonMessages.accountnumber_fullrequired, (value) => {
            // Check if the value contains "XXXX"
            return !value || !value.includes('XXXX');
        }),
});

export const    LOCATIONMANAGERMYPROFILE_SCHEMA = Yup.object().shape({  
    name: Yup.string().required(CommonMessages.name_required),
});